module.exports = "/_next/static/images/parallax-1-9fe09860185babb8e57cf572a6400a34.jpg.webp";